/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.25"
        height="82.25"
        viewBox="0 0 82.25 82.25"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M41.04 1.27a1.26 1.26 0 0 1 1.24 1.13v77.1a1.24 1.24 0 0 1-1.27 1.22 1.26 1.26 0 0 1-1.22-1.1V2.5a1.26 1.26 0 0 1 1.25-1.23Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M79.5 39.97a1.242 1.242 0 0 1 .13 2.48H2.5a1.24 1.24 0 0 1-1.31-1.18 1.25 1.25 0 0 1 1.18-1.32H79.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M29.11 19.62a1.252 1.252 0 0 1 .13 2.5H12.05a1.25 1.25 0 0 1-1.31-1.19 1.24 1.24 0 0 1 1.18-1.31ZM69.16 19.62a1.252 1.252 0 0 1 .13 2.5H52.1a1.25 1.25 0 0 1-1.31-1.19 1.24 1.24 0 0 1 1.18-1.31ZM69.16 55.3a1.25 1.25 0 0 1 1.23 1.27 1.27 1.27 0 0 1-1.1 1.22H52.1a1.25 1.25 0 0 1-1.31-1.19 1.24 1.24 0 0 1 1.18-1.31h17.19ZM69.16 64.81A1.27 1.27 0 0 1 70.48 66a1.25 1.25 0 0 1-1.19 1.31H52.1a1.242 1.242 0 0 1-.13-2.48h17.19Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M20.58 11.13a1.23 1.23 0 0 1 1.24 1.11v17.2a1.24 1.24 0 0 1-1.27 1.22 1.26 1.26 0 0 1-1.22-1.1V12.38a1.24 1.24 0 0 1 1.25-1.25ZM25.73 54.04a1.25 1.25 0 0 1 1.86 1.66l-.1.1-12.06 12.07a1.24 1.24 0 0 1-1.76.07 1.25 1.25 0 0 1-.1-1.74l.09-.09Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M13.66 54.04a1.26 1.26 0 0 1 1.67-.09l.1.09L27.5 66.11a1.24 1.24 0 0 1 0 1.76 1.26 1.26 0 0 1-1.63.1l-.1-.09-12.08-12.07a1.27 1.27 0 0 1-.03-1.77Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M68 0H14.25A14.28 14.28 0 0 0 0 14.24V68a14.28 14.28 0 0 0 14.25 14.24H68A14.28 14.28 0 0 0 82.25 68V14.24A14.28 14.28 0 0 0 68 0ZM14.25 2.5H68a11.78 11.78 0 0 1 11.75 11.74V68A11.78 11.78 0 0 1 68 79.74H14.25A11.78 11.78 0 0 1 2.5 68V14.24A11.78 11.78 0 0 1 14.25 2.5Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'SquareWithPlusMinusMultiplyEqualQuadrantsIcon';

export default Icon;
